import type { StripeElementLocale, StripeElementsOptionsMode } from '@stripe/stripe-js';

// How both Stripe groups on step 3 — the card form and the wallet buttons — are set up, in one place. Deferred mode:
// a card becomes a payment method in the browser, with no intent, and the server takes its id as before.
export function elementsOptions(currency: string | undefined, language: string): StripeElementsOptionsMode {
    return {
        locale: language as StripeElementLocale,
        mode: 'setup',
        currency: (currency || 'usd').toLowerCase(),
        paymentMethodCreation: 'manual',
        paymentMethodTypes: ['card'],
        appearance: {
            theme: 'stripe',
            variables: { colorPrimary: '#0080ff', borderRadius: '12px', colorText: '#0b2a4a' },
        },
    };
}
